import React from "react";
import { Link } from "react-router-dom";

function Login(props) {
  return (
    <>
      <div className="content-center">
        <div className="dx-signin-content dx-signin text-center">
          <h1 className="h3 text-white mb-30">Log In</h1>
          <form action="#" className="dx-form">
            <div className="dx-form-group-md">
              <Link
                to="/account"
                className="dx-btn dx-btn-block dx-btn-popup dx-btn-envato d-flex align-items-center justify-content-center"
              >
                <span className="fas fa-leaf mr-20"></span>
                <span>Log in with Envato</span>
              </Link>
            </div>
            <div className="dx-form-group-md">
              <div className="dx-signin-or">OR</div>
            </div>
            <div className="dx-form-group-md">
              <input
                type="text"
                className="form-control form-control-style-4"
                placeholder="Username Or Email"
              />
            </div>
            <div className="dx-form-group-md">
              <input
                type="password"
                className="form-control form-control-style-4"
                placeholder="Password"
              />
            </div>
            <div className="dx-form-group-md">
              <Link to="/account" className="dx-btn dx-btn-block dx-btn-popup">
                Log In
              </Link>
            </div>
            <div className="dx-form-group-md">
              <div className="d-flex justify-content-between">
                <Link to="/reset-password">Reset your password</Link>
                <Link to="/register">Sign Up</Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
